import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.css']
})
export class SlideshowComponent implements OnInit, OnDestroy {
  _slides: string[] = [];
  private _dragulaSub: Subscription
  @Output() slidesChange = new EventEmitter<string[]>();
  @Input()
  get slides() { return this._slides };
  set slides(value: string[]) {
    this._slides = value || [];
    this.slidesChange.emit(this._slides);
  };
  @Input() showSliderArrows: boolean;
  @Input() sliderAutoPlay: boolean;
  @Output() onSave = new EventEmitter<string[]>();

  constructor(
    public dragulaService: DragulaService
  ) { }

  ngOnInit() {
    if (!this._slides) {
      this._slides = [];
    }
    this._dragulaSub = this.dragulaService.dropModel.subscribe(domStuff => this.save());
  }

  ngOnDestroy() {
    try {
      if (this.dragulaService) {
        this.dragulaService.destroy('slideshow-bag');
      }
      if (this._dragulaSub && !this._dragulaSub.closed) {
        this._dragulaSub.unsubscribe();
      }
    }
    catch (err) {
      console.warn('ngOnDestroy error caught:', err);
    }
  }

  save() {
    this.slides = this._slides;
    this.onSave.emit(this._slides);
  }

  removeSlider(index) {
    if (confirm('Are you sure?')) {
      this._slides.splice(index, 1);
    }
  }

  addSlider() {
    if (typeof this._slides === "undefined") {
      this._slides = [];
    }
    this._slides.push('');
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/slideshow/slideshow.component.ts